export async function getInitialProps({context: {domain}, routeInfo: {location}}) {
  const {
    query: {adId}
  } = location

  const [adDetailsError, adDetailsResponse] = await domain.get('get_ad_details_ads_use_case').execute({adId})

  if (adDetailsError) {
    return {
      __HTTP__: {
        redirectTo: '/'
      }
    }
  }

  const [professionalActivitiesError, professionalActivitiesResponse] = await domain
    .get('get_professional_activities_transactions_use_case')
    .execute()

  const professionalActivitiesList = professionalActivitiesError ? {} : professionalActivitiesResponse

  return {
    adPrice: adDetailsResponse.ad?.price,
    adSeller: adDetailsResponse?.seller?.user?.userId,
    adTitle: adDetailsResponse.ad?.title,
    professionalActivitiesList
  }
}
